<template>
  <div>
    <table v-if="!selectedTrigger">
      <tbody>
        <tr v-for="trigger in triggers" @click="selectedTrigger = trigger">
          <td>{{ trigger.label }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="selectedTrigger">
      <hr>
      <h3>{{ selectedTrigger.label }}</h3>

      <table>
        <tbody>
          <tr>
            <td width="150">
              <select v-model="operator">
                <option value="eq">är lika med</option>
                <option value="ne">är inte lika med</option>
                <option value="gt">är över</option>
                <option value="gte">är över eller exakt</option>
                <option value="lt">är under</option>
                <option value="lte">är under eller exakt</option>
              </select>
            </td>
            
            <td>
              <div v-if="triggerType === 'number'">
                <input type="number" :max="selectedTrigger.max" :min="selectedTrigger.min" v-model.number="triggerValue">
              </div>
        
              <div v-if="triggerType === 'clock'">
                <input type="time" v-model="triggerValue">
              </div>
        
              <div v-if="triggerType === 'enum'">
                <select v-model="triggerValue">
                  <option v-for="(value, index) in this.selectedTrigger.values" :value="index">{{ value }}</option>
                </select>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'trigger_time',
    props: ['type'],
    data () {
      return {
        selectedTrigger: null,
        triggerValue: null,
        sendTriggerTimer: null,
        operator: 'eq'
      }
    },
    created() {
      this.sendTriggerTimer = setInterval(() => {
        this.$emit('options', {
          trigger: this.formattedTrigger,
          operator: this.operator
        })
      }, 100)
    },
    
    destroyed () {
      clearInterval(this.sendTriggerTimer)
    },
    methods: {
      didChange () {
      }
    },
    computed: {
      formattedTrigger () {
        if (!this.selectedTrigger)
          return {}
          
        const obj = {
          systemType: 'time',
          subtype: this.selectedTrigger.id,
          operator: this.operator,
          value: this.triggerValue
        }
          
        return obj
      },

      triggers () {
        return [
          {
            id: 'clock',
            label: 'Klockan... (23:58)',
            type: 'clock'
          },
          {
            id: 'minute',
            label: 'Minuten... (58)',
            type: 'number',
            min: 0,
            max: 59
          },
          {
            id: 'hour',
            label: 'Timmen... (23)',
            type: 'number',
            min: 0,
            max: 59
          },
          {
            id: 'weekday',
            label: 'Veckodag',
            type: 'enum',
            values: ['måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag', 'söndag']
          },
          {
            id: 'month',
            label: 'Månaden',
            type: 'enum',
            values: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
          }
        ]
      },

      triggerType () {
        if (this.selectedTrigger)
          return this.selectedTrigger.type
        return ''
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/automationer/trigger_time.vue